import {
  animate,
  animateChild,
  group,
  query,
  stagger,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const CC_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

/** The whole card fades up once, then hands off to the staggered children. */
export const ccCard = trigger('ccCard', [
  state('hidden', style({ opacity: 0, transform: 'translateY(34px)' })),
  state('shown', style({ opacity: 1, transform: 'none' })),
  transition('hidden => shown', [
    group([
      animate(`480ms ${CC_EASE}`),
      query('@*', animateChild(), { optional: true }),
    ]),
  ]),
]);

/** Left column: badge, heading, description, then each trust point. */
export const ccAside = trigger('ccAside', [
  transition('hidden => shown', [
    query(':scope > *', style({ opacity: 0, transform: 'translateY(18px)' }), {
      optional: true,
    }),
    query(
      ':scope > *',
      stagger(70, [
        animate(`420ms ${CC_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);

/** Right column: fields land top to bottom, submit row last. */
export const ccFields = trigger('ccFields', [
  transition('hidden => shown', [
    query('.cc-field, .cc__actions', style({ opacity: 0, transform: 'translateY(20px)' }), {
      optional: true,
    }),
    query(
      '.cc-field, .cc__actions',
      stagger(60, [
        animate(`400ms ${CC_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);
